import React, { useState, useContext, useEffect } from "react";
import getProfileLabel from "../genericFunctions/getProfileLabel";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";

const Presentation = (props) => {
  const onSubmitPresentation = props.onSubmitPresentation;
  const [presentation, setPresentation] = useState({
    presentation: props.presentation,
  });
  const [editing, setEditing] = useState(false);
  const authContext = useContext(AuthContext);
  const history = useHistory();

  useEffect(() => {
    if (!authContext.isAuthenticated) {
      history.push("/login");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onChange = (e) => {
    setPresentation({ presentation: e.target.value });
  };

  return (
    <div
      style={{
        margin: "10px 10px 10px 0px",
        padding: "10px 0px 10px 0px",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "10px",
            borderBottom: "1px solid #e1e1e1",
          }}
        >
          <h4>{getProfileLabel(props.profileLanguage, "presentation")}</h4>
          {!editing && (
            <IconButton
              onClick={() => {
                setEditing(true);
                setPresentation({
                  presentation: props.presentation,
                });
              }}
              variant="outlined"
              color="primary"
            >
              <EditIcon />
            </IconButton>
          )}
        </div>
        {!editing && presentation.presentation === "" ? (
          <>
            <p style={{ marginTop: "1rem", marginBottom: "1rem" }}>
              {getProfileLabel(props.profileLanguage, "noPresentation")}
            </p>
          </>
        ) : !editing ? (
          <p style={{ whiteSpace: "pre-wrap", margin: "0px" }}>
            {props.presentation}
          </p>
        ) : (
          <form
            onSubmit={(e) => {
              setEditing(false);
              onSubmitPresentation(e, presentation);
            }}
            style={{ margin: "20px 0px" }}
          >
            <TextField
              type="text"
              name="presentation"
              label="My presentation"
              value={presentation.presentation}
              onChange={onChange}
              className="form-cotrol"
              multiline
              rows={4}
              variant="outlined"
              placeholder="Enter a presentation"
              style={{ margin: "0px 0px 10px 0px", width: "100%" }}
            />
            <Button
              type="submit"
              variant="outlined"
              color="primary"
              style={{ margin: "0px 5px 0px 0px" }}
              onClick={() => {}}
            >
              Save
            </Button>
            <Button
              onClick={() => {
                setEditing(false);
                setPresentation({
                  presentation: props.presentation,
                });
              }}
              variant="outlined"
              color="secondary"
            >
              Cancel
            </Button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Presentation;
